<template>
  <div class="mainBox">
    <div class="mainCon">
      <stu-main-title></stu-main-title>
      <div class="content">
        <template v-if="auditState == 0">
          <div class="examine-state">
            <div class="examine-box">
              <div class="examine-state-img">
                <img src="../../../assets/stuImg/examine-wait.png" alt="" />
              </div>
              <div class="examine-state-text">
                <div class="examine-state-title">待审核</div>
                <div class="examine-state-content">
                  您的成绩复核申请已提交，请等待审核
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="auditState == 2">
          <div class="examine-box">
            <div class="examine-state-img">
              <img src="@/assets/img/pass.png" alt="" />
            </div>
            <div class="examine-state-text">
              <div class="examine-finsh">审核通过</div>
              <div class="examine-state-content">您的成绩复核申请已通过，以下为您的成绩复核结果</div>
            </div>
          </div>
          <div>
            <template>
              <ots-table-new
                :tableHeader="tableHeader"
                :tableData="tableData"
              ></ots-table-new>
            </template>
          </div>
        </template>
        <template v-if="auditState == 1">
          <div class="examine-box">
            <div class="examine-state-img">
              <img src="@/assets/img/unpass.png" alt="" />
            </div>
            <div class="examine-state-text">
              <div class="examine-error">审核不通过</div>
              <div class="examine-state-content">
                <span>原因：</span>
                <span class="examine-error-reason">{{ auditRemark }}</span>
              </div>
            </div>
          </div>
          <div class="sectionBox" v-if="this.allowReApply == 1">
            <div class="avatarTips">
              <el-upload
                action=""
                class="avatar-uploader dinb"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :http-request="uploadImg"
              >
                <img v-if="tabimg.applyFilePath" :src="tabimg.applyFilePath" alt="" />
                <img v-else src="../../../assets/img/photo.png" alt=""> 
              </el-upload>
            </div>
            <div class="avatarTip">
              <p class="mb10">申请表上传要求</p>
              <p class="col_grayQ">
                1、请先下载
                <span class="clickclass" @click="Representa">申请表模板</span
                >，打印出来后用黑色签字笔填写并签字
              </p>
              <p class="col_grayQ">2、将签完字的申请表拍照并上传；</p>
            </div>
          </div>
        </template>
      </div>

      <div
        class="sectionBox"
        v-if="auditState != 0 && auditState != 1 &&  auditState != 2"
      >
        <div class="avatarTips">
          <el-upload
            action=""
            class="avatar-uploader dinb"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadImg"
          >
            <img v-if="tabimg.applyFilePath" :src="tabimg.applyFilePath" alt="" />
            <img v-if="!tabimg.applyFilePath" src="../../../assets/img/photo.png" alt="">
          </el-upload>
        </div>
        <div class="avatarTip">
          <p class="mb10">申请表上传要求</p>
          <p class="col_grayQ">
            1、请先下载
            <span class="clickclass" @click="Representa">申请表模板</span
            >，打印出来后用黑色签字笔填写并签字
          </p>
          <p class="col_grayQ">2、将签完字的申请表拍照并上传；</p>
        </div>
      </div>
    </div>

    <ots-custom-dialog
      :dialog.sync="InfoDialog"
      :title="'查看分项成绩'"
      width="60%"
    >
      <template v-slot:content>
        <ots-table-new
          :tableHeader="detailTableHeader"
          :tableData="detailTableData"
        ></ots-table-new>
      </template>
    </ots-custom-dialog>

    <ots-custom-dialog
      :dialog.sync="noticeDialog"
      :title="'系统提示'"
      width="40%"
    >
      <template v-slot:content>提交后不能修改，是否确定提交？</template>
      <template v-slot:footer>
        <el-button round @click="addDialog">取消</el-button>
        <el-button round type="primary" @click="addSchool">确定</el-button>
      </template>
    </ots-custom-dialog>
    <stu-foot v-if="auditState=== null || (this.allowReApply ==1  && this.auditState !=2)"
      cancelText="取消"
      @cancel="cancel"
      confirmtext="提交申请表"
      @confirm="UpdateRegistrationFN('ruleForm')"
    ></stu-foot>
  </div>
</template>

<script >
import stuFoot from "../components/stuFoot.vue";
import { getSinglePlan } from "@/http/modules/examSet/examBatch";
import {
  downRepresen,
  ScoreReview,
  usergetScoreReview,
  getStudentScoreReviewSubCourseInfoAPI,
  getStudentScoreReviewSubCourseDetailAPI
} from "@/http/modules/student/score";

export default {
  components: {
    stuFoot,
  },
  name: "representations",
  data() {
    return {
      tabimg: {
        applyFilePath: "",
      },
      InfoDialog: false,
      allowReApply: "",
      ruledata: "",
      auditRemark: "",
      fileData: "",
      noticeDialog: false,
      auditState: "",
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "考试科目",
          prop: "courseName",
        },
        {
          title: "成绩",
          prop: "score",
          formatter: (scope) => {
            return scope.row.score + "/" + scope.row.fullScore;
          }
        },
      ],
      tableData: [],
      scoreReviewShowSubCourseScore: 0,

      detailTableHeader: [
        {
          title: "题型",
          prop: "questionTypeName",
        },
        {
          title: "题号",
          prop: "qseq",
        },
        {
          title: "分值",
          prop: "fullScore",
        },
        {
          title: "得分",
          prop: "score",
          align:'center',
          headerAlign: "center",
          type: "tag_Q",
          tagColor: (scope) => {
            return scope.row.score != scope.row.fullScore ? "col_red": "col_green"
          },
        }
      ],
      detailTableData: [],
      // 是否已经上传
      isHaveUpload:false,
    };
  },
  created() {
    this.usergetScore();
  },

  mounted() {
    this.getPlanInfo();
  },

  methods: {
    async getPlanInfo() {
      let planId = this.getCurrentGlobalPlanId();
      const { data, code } = await getSinglePlan({planId});
      let item = {
        title: "操作",
        type: "buttons",
        btnList: [
          {
            title: (scope) => {
              if (scope.row.subCourseCode) {
                return  "查看分项成绩";
              } else {
                return " - "
              }
            },
            click: this.showScoreDetail,
            formatter: (scope) => {
              return scope.row.subCourseCode ? false: true;
            }
          },
        ],
      }
      if (code) {
        this.scoreReviewShowSubCourseScore = data.scoreReviewShowSubCourseScore;
        if (data.scoreReviewShowSubCourseScore == 1) {
          this.tableHeader.push(item);
        } else {
          this.tableHeader = this.tableHeader.slice(0, 3);
        }
      }
    },

    async showScoreDetail(row) {
      let params = {
        studentCourseId: this.$route.query.studentCourseId,
        subCourseCode: row.subCourseCode
      }
      const { code, data } = await getStudentScoreReviewSubCourseDetailAPI(params);
      if (code) {
        this.InfoDialog = true;
        this.detailTableData = data;
      }
    },

    beforeAvatarUpload(fileData) {
      this.fileData = fileData;
      let ImgRules = ["jpg", "jpeg"];
      let type = fileData.name.substring(fileData.name.lastIndexOf(".") + 1);
      const isJPG = ImgRules.indexOf(type) !== -1;
      if (!isJPG) {
        this.$message.error("文件格式错误，只能上传 JPG，JPEG 格式文件！");
        return false;
      }
      // const reader = new FileReader();
      // reader.readAsDataURL(fileData);
      // reader.onload = () => {
      //   const base64 = reader.result;
      //   this.tabimg.applyFilePath = base64;
      // }
      return isJPG;
    },
    async Representa() {
      //学生，下载申请表模板
      const { data } = await downRepresen({
        planId: this.$route.query.id,
      });
      if (data) {
        window.open(data);
      }
    },
    async usergetScore() {
      const { data } = await usergetScoreReview({
        planId: this.$route.query.id,
        studentCourseId: this.$route.query.studentCourseId,
      });
      let arritemdata = [];
      if(data){
        data.applyFilePath = ''
        this.tabimg = data;
        this.allowReApply = data.allowReApply
        this.auditRemark = data.auditRemark;
        this.auditState = data.auditState;
        arritemdata.push(data);
      }
      // 测试接口可用性
      const { code, data: subCourseInfo } = await getStudentScoreReviewSubCourseInfoAPI({"studentCourseId": this.$route.query.studentCourseId});
      if (code) {
        if (subCourseInfo.length == 1) {
          if(arritemdata.length>0){
            arritemdata[0].subCourseCode = subCourseInfo[0].subCourseCode;
          }
          this.tableData = arritemdata;
        } else {
          this.tableData = [...arritemdata, ...subCourseInfo];
        }
      }
    },

    uploadImg(data) {
      let that = this;
      this.fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(this.fileData);
      reader.onload = function (e) {
        if (e.currentTarget.result) {
          that.tabimg.applyFilePath = e.currentTarget.result;
          that.isHaveUpload = true;
        }
      };
    },

    
    addSchool(data) {
      let formData = new FormData();
      formData.append("planId", this.$route.query.id);
      formData.append("studentCourseId", this.$route.query.studentCourseId);
      formData.append("file", this.fileData);
      ScoreReview(formData).then((res) => {
        if (res.code == 1) {
          this.noticeDialog = false;
          this.$message.success(res.data);
          this.usergetScore();
        }
      });
    },
    addDialog() {
      this.noticeDialog = false;
    },
    getAvatarUrl() {
      return require("../../../assets/img/auto-photo.jpg");
    },
    cancel() {
      this.$router.push({
        path: "/stuHome/score",
      });
    },
    UpdateRegistrationFN() {
      if(this.isHaveUpload){
        this.noticeDialog = true;
      }else{
        this.$message.warning("请上传成绩复核申请表!");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.sectionBox {
  margin-top: 30px;
  display: flex;
  position: absolute;
}
.mainBox {
  background: #fff;
  border-radius: 8px;
}
.mainCon {
  height: 500px;
}
.vatar-uploader .dinb {
  width: 140px;
  height: 183px;
  img {
    width: 100%;
  }
}

.avatar-uploader.dinb {
  img {
    width: 100%;
  }
}


.avatar-uploader /deep/ .el-upload:hover {
  border-color: #006aff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 160px;
  height: 200px;
  line-height: 131px;
  text-align: center;
  border: 1px dashed #006aff !important;
  opacity: 0;
  position: absolute;
}
.avatarTip {
  margin-left: 20px;
  text-align: left;
}
.clickclass {
  color: #006aff;
  cursor: pointer;
}
.mainBox {
  width: 100%;
  min-width: 700pt;
  background-color: #fff;
  border-radius: 8px;
}
.mainCon {
  box-sizing: border-box;
  padding: 20px;
  padding-top: 16px;
  height: 620px;
  width: 100%;
  background: rgba(255, 255, 255, 0.93);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  .content {
    padding-top: 48px;
    text-align: center;
  }
}
.examine-box {
  div {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 8px;
  }
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 30px;
}
.examine-btn {
  display: inline-flex;
  padding: 8px 26px;
  color: #fff;
  background-color: #006aff;
  border-radius: 100px;
  margin-left: 30px;
  margin-top: 30px;
  cursor: pointer;
}
.examine-state-img {
  height: 48px;
  img {
    width: 48px;
    height: 48px;
    display: block;
  }
}
.examine-state {
  display: flex;
  justify-content: center;
}
.examine-state-text {
  padding-left: 12px;
  line-height: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .examine-state-title {
    color: #f27900;
    font-weight: bold;
    font-size: 24px;
    text-align: left;
  }
  .examine-state-content {
    color: #9299a6;
    font-size: 14px;
    margin-top: 5px;
    .examine-error-reason {
      color: #45494d;
    }
    text-align: left;
  }
}
.examine-finsh {
  color: #1dbf60;
  font-weight: bold;
  font-size: 24px;
  text-align: left;
}
.examine-error {
  color: red;
  font-weight: bold;
  font-size: 24px;
  text-align: left;
}
.img_style {
  width: 140px;
  height: 183px;
  img {
    width: 100%;
    height: 100%;
  }
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.avatarTips {
  width: 160px;
  height: 200px;
  padding-top: 8px;
  vertical-align: top;
  line-height: 1.8;
  margin-left: 15px;
}
</style>